import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'main',
    component: () => import('@/pages/main/index.vue'),
    meta: {
      keepAlive: false, //需要缓存的页面
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/login/index.vue'),
    meta: {
      keepAlive: false, //需要缓存的页面,
      title: '登录'
    },
  },
  {
    path: '/user',
    name: 'user',
    component: () => import('@/pages/user/index.vue'),
    meta: {
      keepAlive: false, //需要缓存的页面,
      title: '个人中心'
    },
  },
  {
    path: '/video',
    name: 'videos',
    component: () => import('@/pages/video/index.vue'),
    meta: {
      keepAlive: false, //需要缓存的页面,
      title: '视频'
    },
  },
  {
    path: '/moreVideo',
    name: 'moreVideo',
    component: () => import('@/pages/video/moreVideo.vue'),
    meta: {
      keepAlive: false, //需要缓存的页面,
      title: '更多视频'
    },
  },
  {
    path: '/products',
    name: 'products',
    component: () => import('@/pages/products/index.vue'),
    meta: {
      keepAlive: false, //需要缓存的页面,
      title: '产品'
    },
  },
  {
    path: '/news',
    name: 'news',
    component: () => import('@/pages/news/index.vue'),
    meta: {
      keepAlive: false, //需要缓存的页面,
      title: '新闻'
    },
  },
  {
    path: '/newsMain',
    name: 'newsMain',
    component: () => import('@/pages/news/main.vue'),
    meta: {
      keepAlive: false, //需要缓存的页面,
      title: '新闻'
    },
  },
  {
    path: '/serve',
    name: 'serve',
    component: () => import('@/pages/serve/index.vue'),
    meta: {
      keepAlive: false, //需要缓存的页面,
      title: '服务'
    },
  },
  {
    path: '/contect',
    name: 'contect',
    component: () => import('@/pages/contect/index.vue'),
    meta: {
      keepAlive: false, //需要缓存的页面,
      title: '联系'
    },
  },
  {
    path: '/memo',
    name: 'memo',
    component: () => import('@/pages/memo/index.vue'),
    meta: {
      keepAlive: false, //需要缓存的页面,
      title: '纪念馆'
    },
  },
  {
    path: '/homeMemo',
    name: 'homeMemo',
    component: () => import('@/pages/homeMemo/home.vue'),
    meta: {
      keepAlive: false, //需要缓存的页面,
      title: '快速建馆'
    },
  },
  {
    path: '/personal',
    name: 'personal',
    component: () => import('@/pages/personal/index.vue'),
    meta: {
      keepAlive: false, //需要缓存的页面,
      title: '私人馆'
    },
  },
  {
    path: '/dimension',
    name: 'dimension',
    component: () => import('@/pages/dimension/index.vue'),
    meta: {
      keepAlive: false, //需要缓存的页面,
      title: '动漫馆'
    },
  },
  {
    path: '/edit',
    name: 'edit',
    component: () => import('@/pages/memo/edit.vue'),
    meta: {
      keepAlive: false, //需要缓存的页面,
      title: '纪念馆'
    },
  },
  {
    path: '/worship',
    name: 'worship',
    component: () => import('@/pages/worship/index.vue'),
    meta: {
      keepAlive: false, //需要缓存的页面,
      title: '祭奠'
    },
  },
  {
    path: '/outer',
    name: 'outer',
    component: () => import('@/pages/outer/index.vue'),
    meta: {
      keepAlive: false, //需要缓存的页面,
      title: '陵园'
    },
  },
  {
    path: '/venue',
    name: 'venue',
    component: () => import('@/pages/venue/index.vue'),
    meta: {
      keepAlive: false, //需要缓存的页面,
      title: '快速建馆'
    },
  },
  {
    path: '/search',
    name: 'search',
    component: () => import('@/pages/search/index.vue'),
    meta: {
      keepAlive: true, //需要缓存的页面,
      title: '搜索'
    },
  },
  {
    path: '/founder',
    name: 'founder',
    component: () => import('@/pages/homeMemo/founder.vue'),
    meta: {
      keepAlive: true, //需要缓存的页面,
      title: '始祖纪念馆'
    },
  },
  {
    path: '/cemetery',
    name: 'cemetery',
    component: () => import('@/pages/homeMemo/cemetery.vue'),
    meta: {
      keepAlive: true, //需要缓存的页面,
      title: '陵园'
    },
  },
  {
    path: '/doctary',
    name: 'doctary',
    component: () => import('@/pages/doctary/index.vue'),
    meta: {
      keepAlive: true, //需要缓存的页面,
      title: '纪录片'
    },
  },
  {
    path: '/follow',
    name: 'follow',
    component: () => import('@/pages/follow/index.vue'),
    meta: {
      keepAlive: true, //需要缓存的页面,
      title: '我的关注'
    },
  },
  {
    path: '/public',
    name: 'public',
    component: () => import('@/pages/public/index.vue'),
    meta: {
      keepAlive: true, //需要缓存的页面,
      title: '公众纪念馆'
    },
  },
  {
    path: '/stele',
    name: 'stele',
    component: () => import('@/pages/stele/index.vue'),
    meta: {
      keepAlive: true, //需要缓存的页面,
      title: '纪念碑'
    },
  },
  {
    path: '/river',
    name: 'river',
    component: () => import('@/pages/riverLamp/index.vue'),
    meta: {
      keepAlive: false, //需要缓存的页面,
      title: '河灯'
    },
  },

]
export default routes
